import { Component, OnInit, AfterViewInit, Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonService } from '../common.service';
import { ApiService } from '../api.service';
import { StoreService } from '../store.service';
import { CookieService } from 'ngx-cookie-service';

declare var VConsole: any;

@Component({
  selector: 'app-learning-map',
  templateUrl: './learning-map.component.html',
  styleUrls: ['./learning-map.component.css']
})
export class LearningMapComponent implements OnInit, AfterViewInit {

  //学习地图信息
  @Input() user_target: boolean;
  @Input() learningTour: any; //learningTour
  @Input() UserID: any; //用户id
  @Input() themeBG: string; //主题背景
  @Input() isShowEnterAnimate: boolean; //是否显示切换动画
  @Input() campList: any; //训练营列表
  transBaseUrl = '';
  companyMetaId: number;
  assetsRoute = '../../assets';
  progressLists: any;
  progress = 0;
  isPC = false;
  isWxWork = false;
  haveBreakPoint = false;
  isVisitorToolsGuide = false;
  isHaveTools = false;
  userBreakPoint: any;
  circleTheme = {
    'width': 300, //环形长度
    'height': 300, //环形高度
    'x': 0, //圆心x坐标
    'y': 0, //圆心y坐标
    'radius': 90, //外环半径
    'innerRadius': 20, //圆环厚度
    'startAngle': 0, //开始角度
    'endAngle': 360, //结束角度
    'angleRadian': 275, //环形轨迹角度
    'colors': ['#7E9FFB', '#5F81DB', '#60B68A', '#44976C', '#EEE'] //环形颜色
  }; //主题
  //客制化logo父盒子
  verticalLogoSize = [0, 0];
  customizeMetaInfo = {
    logoUrl: '',
    companyName: '',
    width: 0,
    height: 0
  };
  constructor(private route: ActivatedRoute,
              private router: Router,
              private apiService: ApiService,
              private cookieService: CookieService,
              private commonService: CommonService,
              private storeService: StoreService) {}
  //客制化部分
  fitLogoImgs(logoUrl){
    // 获取设备宽度
    const deviceWidth = window.innerWidth;
    //上下结构的logo盒子宽
    const verticalLogoSize = this.verticalLogoSize = [
      80,
      // deviceWidth*.27,
      // deviceWidth*.45,
      80
    ];

    const v_ratio = verticalLogoSize[0] / verticalLogoSize[1];


    const newImg = document.createElement('img');
    newImg.style.display = 'none';
    newImg.onload = () => {
      const imgRatio = newImg.width / newImg.height;
      if ( imgRatio < v_ratio){

        this.customizeMetaInfo.height = verticalLogoSize[1];
        this.customizeMetaInfo.width = verticalLogoSize[1] * imgRatio;
      }else{
        this.customizeMetaInfo.width = verticalLogoSize[0];
        this.customizeMetaInfo.height = verticalLogoSize[0] / imgRatio;
      }
      this.customizeMetaInfo.logoUrl = logoUrl;
    };
    newImg.src = logoUrl;

  }
  getCustomizeMetaInfo(){
    this.apiService.getCustomizeMetaInfo().subscribe(res => {
      const {logoUrl, title} = res;
      this.customizeMetaInfo.companyName = title;
      this.fitLogoImgs(logoUrl);
    });
  }
  ngOnInit() {
    const self = this;
    
    // 立即触发用户状态检查
    console.log('learning-map ngOnInit: 触发立即检查用户状态');
    this.storeService.notification.askImmediately.next(true);
    
    this.getCustomizeMetaInfo();
    // 清除项目相关信息
    localStorage.removeItem('projectmsg');
    localStorage.removeItem('projectId');
    // 清除训练营相关信息
    localStorage.removeItem('skuId');
    localStorage.removeItem('campId');
    //客制化开始
    $('#learningPathMetaIdContainer').val('');
    this.isHaveTools = localStorage.getItem('isHaveTools') ? JSON.parse(localStorage.getItem('isHaveTools')) : false;
    this.assetsRoute = this.commonService.setAssetsRoute(this.assetsRoute);
    this.transBaseUrl = window['transBaseUrl'];
    this.isWxWork = this.commonService.isWxWork();
    //进入学地图时,各能力学习时长不计时
    localStorage.setItem('learningPathMetaId', '');
    this.companyMetaId = this.learningTour.tour_meta_id;
    // this.isPC = localStorage.getItem('isPC') ? true : false;
    this.isPC = !!localStorage.getItem('isPC');
    this.learningTour.projectList.forEach(item  => {
      item.allCouseNum = Number(item.totalCourseNum ? item.totalCourseNum : 0) + Number(item.totalCampMetasNum ? item.totalCampMetasNum : 0);
      if (item.totalCampMetasNum && item.totalCampMetasNum == 1 && (!item.totalCourseNum || item.totalCourseNum == 0)){  // 判断有且仅有一门训练营课程
        item.isOnlyCampCourse = true;
        item.campMetasList[0].campOpenTime = item.campMetasList[0].preTestOpenTime ? self.tansFromTimestamp(item.campMetasList[0].preTestOpenTime, 1) : '';
      }
    });

    this.getUserBreakPoint().then(result => {
      this.userBreakPoint = result;
      this.haveBreakPoint = result.breakpointUrl && !localStorage.getItem('skuId') && !sessionStorage.getItem('userSession') && !result.breakpointUrl.includes('huatek') ;

      if (self.userBreakPoint.projectId){
        self.getCourseitemsLock(this.userBreakPoint.learningPathMetasId, this.userBreakPoint.projectId).then(res => {
          res.forEach(itm => {
            const openAt = itm.openAt;
            itm.openTime = openAt ? self.tansFromTimestamp(openAt, 1) : '';
            itm.promptTime = openAt ? self.tansFromTimestamp(openAt, 2) : '';
          });
          localStorage.setItem('projectId', this.userBreakPoint.projectId);
          localStorage.setItem('projectmsg', JSON.stringify(res));
        });
      }
    }).then(() => {
      if (this.isHaveTools){
        this.commonService.getOnceIno(99999).then(result => {
          this.isVisitorToolsGuide = result !== 1;
        });
      }
    }).then(() => {
      sessionStorage.setItem('userSession', this.UserID);
      this.setProgressInLearningTour();
    });


    // 获取项目列表
    // this.getProjectProgress().then(result => {
    //   let res = this.msgSort(result, 'projectCreateTime', 1)
    //   this.learningTour.projectList = res
    // });

  }

  setPinpointPicture(id) {
    return 'https://ddileaf-uat-oss.oss-cn-shanghai.aliyuncs.com/scorm/pinpoint/' + encodeURIComponent(this.commonService.getPinpointCourseEnNameById(id).trim());
  }

  // 时间转化
  tansFromTimestamp(timestamp, type){
    const date = new Date(timestamp);
    const Y = date.getFullYear();
    const M = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : (date.getMonth() + 1);
    const D = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
    const h = date.getHours() < 10 ? '0' + date.getHours() : date.getHours();
    const m = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes();
    const s = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();
    if (type == 1){
      return `${M}.${D}`;
    }else if (type == 2){
      return `${Y}-${M}-${D} ${h}:${m}`;
    }
  }

  //控制测,学,练,考是否锁住
  getCourseitemsLock(learningPathMetaId, projectId){
    return this.apiService.ajax({
      'type': 'GET',
      'url': 'ddilearner/v2/user/learningpathes/itemsLock/' + String(learningPathMetaId) + '?projectId=' + projectId,
    }).toPromise();
  }


  // 数组对象根据某个属性排序
  msgSort(arr, name, type){
    arr.sort((a, b) => {
      // let t1 = new Date(a[name]);
      // let t2 = new Date(b[name]);
      // return t2.getTime() - t1.getTime();
      if (type == 1){  // 降序，从大到小
        return b[name] < a[name] ? -1 : 1;
      } else {  // 升序，从小到大
        return b[name] > a[name] ? -1 : 1;
      }
    });
    return arr;
  }

  ngAfterViewInit() {
    this.commonService.initPage({
      'backgroundColor': '#F2F3FA'
    });
  }

  //将进度数据插入learningTour
  setProgressInLearningTour(){
    const learningPathMetas = this.learningTour.learning_path_metas;
    this.getUserLearningProgress().then(result => {
      this.progressLists = result;
    }).then(() => {
      if (this.progressLists.length !== 0){
        this.progressLists = this.progressLists[this.getIndexByConditionIdInLists(this.progressLists, 'userId', this.UserID)];
        const progressList = this.progressLists['progressList'];
        for (let i = 0, len = learningPathMetas.length; i < len; i += 1){
          learningPathMetas[i].progress = 0;
          if (progressList[this.getIndexByConditionIdInLists(progressList, 'learningPathMetaId', learningPathMetas[i].id)] && learningPathMetas[i].id !== 22){
            learningPathMetas[i].progress = progressList[this.getIndexByConditionIdInLists(progressList, 'learningPathMetaId', learningPathMetas[i].id)].progress;
          }
        }
      }else{
        for (let i = 0, len = learningPathMetas.length; i < len; i += 1){
          learningPathMetas[i].progress = 0;
        }
      }
    });
  }

  //根据条件在数组中获取下标
  getIndexByConditionIdInLists(Lists, condition, value){
    return (Lists || []).findIndex((v) => v[condition] === value);
  }

  //获取用户学习断点
  getUserBreakPoint(): Promise<any>{
    return this.apiService.ajax({
      'type': 'GET',
      'url': 'sr/breakpoint/getLastLearningbreakpoint'
    }).toPromise();
  }

  //获取用户进度
  getUserLearningProgress(){
    return this.apiService.ajax({
      'type': 'GET',
      'url': 'ddilearner/v2/user/learning/progress',
    }).toPromise();
  }

  //项目列表接口和项目学习进度接口
  // getProjectProgress(){
  //   return this.apiService.ajax({
  //     'type': 'GET',
  //     'url': 'ddilearner/v2/user/learning/projectProgress?needDetails=false',
  //   }).toPromise();
  // }

  //关闭断点
  closeAppBreakPoint(): void{
    this.haveBreakPoint = false;
  }

  goLearnPath(learningMetaId, version?, name?): void {
    let link;
    if (Number(learningMetaId) > 5000 && Number(learningMetaId) < 6000) {
      this.router.navigate(['app-scorm', learningMetaId], { queryParams: { version: version, name: name } });
    } else {
      if (this.user_target){
      link = ['app-experience', 'learning-path', learningMetaId];
    } else {
      link = ['learning-path', learningMetaId];
    }

    if (learningMetaId == 0){
      this.commonService.setStorage('dnaReturnUrl', location.href);
      link = ['survey', this.learningTour.tour_id, 1, 2];
      this.router.navigate(link);
    } else if (learningMetaId == 22) {
      location.href = this.transBaseUrl + '/tr/checkUsers/' + this.UserID;
    } else {
      this.router.navigate(link);
    }
  }
}

  // 进入项目课程页面
  goProjectList(row){
    const self = this;
    console.log(row, '010101');
    if (row.videoId){  // 有视频
      self.router.navigate(['learning-project', row.projectId]);
    }else {
      //这里需要考虑有训练营的情况，就要减去DNA的数量，没有训练营的情况，就不用减去DNA的数量
      const courseLength = row.learningPathMetasDetailList.filter(item => item.learningPathMetaId !== 999).length;
      const campLength = row.campMetasList.length; //训练营的数量
      //进入项目旅程，这里包含过渡版DNA的逻辑，后面会改版
      if ( !campLength   //没有训练营，有课程 或者 没有训练营，有作业
        || campLength > 1 //有大于1个训练营
        || (campLength == 1 && (courseLength > 1 || row.totalHomeworkNum)) //有训练营，有大于1的课程(等于1的要单独判断是否是DNA，是的话，进训练营) 或者 有训练营，有作业
        || (campLength == 1 && (courseLength == 1 && (row.learningPathMetasDetailList[0].learningPathMetaId !== 0 && row.learningPathMetasDetailList[0].learningPathMetaId !== 999))) //有训练营，有1个课程，但不是DNA也不是小工具，进项目旅程
      ){
        self.router.navigate(['learning-project', row.projectId]);
      }else{
        const skuId = row.campMetasList[0].campMetasProjectId;
        const campId = row.campMetasList[0].campMetasId;
        localStorage.setItem('skuId', skuId);
        localStorage.setItem('campId', campId);
        this.CoursesOrProjectCourses(row.projectId).then(res => { //这里因为直接跳训练营旅程页需要项目里的tour_id字段，跳转之前先调用到这个tour_id
          self.commonService.setStorage('tourId', res.tour_id);
          self.router.navigate(['learning-camp', skuId, campId]);
        });
      }
    }
  }

  count = 0;
  showVersion(){
    this.count++;
    if (this.count > 20){
      const vConsole = new VConsole();
      this.count = 0;
    }
  }

  //获取项目下课程列表或者散客列表
  CoursesOrProjectCourses(projectId){
    return this.apiService.ajax({
      'type': 'GET',
      'url': 'sr/v2/coursesOrProjectCourses?projectId=' + projectId,
    }).toPromise();
  }

}



// WEBPACK FOOTER //
// ./src/app/learning-map/learning-map.component.ts